module.exports = __webpack_public_path__ + "img/hinten nacht.df774d92.jpg";